import { useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useStaticPageTitle } from "@/components/header/use-page-title";
import { DarwinPageContext } from "@/types/chatbot.types";

/** The page the user has open, sent with every Darwin message so it knows where the user is. */
export function useDarwinPageContext(): DarwinPageContext {
    const { t } = useTranslation();
    const location = useLocation();
    const titleKey = useStaticPageTitle();

    return {
        path: location.pathname,
        title: titleKey ? t(titleKey) : undefined,
        search: location.search as Record<string, unknown>,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
}
